export default __webpack_public_path__ + "static/media/login-bg.c5460d04.jpg";